import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import CreateIcon from '@/assets/icons/create-icon.svg?react';
import PropTypes from 'prop-types';

const CustomCreateButton = ({ label, onClose, size = 'medium' }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const translate = useTranslate();
    const buttonLabel = label || translate('common.buttonLabels.addNew');

    const handleOpenCreateModal = () => {
        if (onClose) {
            onClose();
        }
        navigate({ pathname: location.pathname, search: location.search, hash: '#create' });
    };

    return (
        <>
            <Button onClick={handleOpenCreateModal} className='white' aria-label={buttonLabel} size={size}>
                <CreateIcon />
                {buttonLabel}
            </Button>
        </>
    );
};

CustomCreateButton.propTypes = {
    label: PropTypes.string,
    onClose: PropTypes.func,
    size: PropTypes.string,
};

export default CustomCreateButton;
